import ES from './es';
import EN from './en';

const datePicker = {
    ES,
    EN
};

export default datePicker;
